import { useIsAuth } from '#modules/user/features/auth/hooks/useIsAuth';
import { LandingFooter } from '#features/landing/components/Landing/Footer';
import { envConfig } from '#constants/envConfig';
import { SlimFooter } from '../SlimFooter';

/**
 * Picks the footer for the current surface. One rule for the site and the app.
 *
 *  - native shell — no footer at all. It is a website chrome: a Google Play button, job
 *    ads and a cookie-settings link inside an installed app are exactly what store
 *    reviewers read as "this is a repackaged site". Terms and Privacy live on the About
 *    screen and under the sign-in form instead.
 *  - signed-in on the web — the slim strip (© · Terms · Privacy · language).
 *  - guest on the web — the full footer, unchanged.
 *
 * Keyed off *auth state*, not screen size, and that is what makes it safe: crawlers are
 * never signed in, so everything Google indexes still carries the full set of internal
 * links. The native branch folds away at build time, so nothing here reaches the web
 * bundle's decision path beyond the auth check.
 */
export const AppFooter = () => {
  const isAuth = useIsAuth();

  if (envConfig.IS_NATIVE) {
    return null;
  }

  return isAuth ? <SlimFooter /> : <LandingFooter />;
};
